
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/footer-for-blog",
      function () {
        return require("private-next-pages/footer-for-blog.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/footer-for-blog"])
      });
    }
  